import { 
    TOUR_PARTNER_DATA_API_START,
    TOUR_PARTNER_DATA_API_SUCCESS,
    TOUR_PARTNER_DATA_API_ERROR
} from "../Constant/TourPartnersConstant";
  
  const initialState = {
    loading: false,
    tourPartnerData: [],
  };
  
  export default function TourPartnersReducer( 
    state = { ...initialState },
    action
  ) {
    switch (action.type) {
      case TOUR_PARTNER_DATA_API_START:
        return {
          ...state,
          loading: true,
        };
      case TOUR_PARTNER_DATA_API_SUCCESS:
        return {
          ...state,
          tourPartnerData: action.payload,
          loading: false,
        };
      case TOUR_PARTNER_DATA_API_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
  }